import styled from "@emotion/styled";
import { ThemeProps } from "../../../../theme/gigatv/ThemeProps";

export const HeaderTextDiv = styled.div<ThemeProps>([
    props => props.gigaTvTheme.typography.fontSize40,
    props => props.gigaTvTheme.typography.regular,
    props => props.gigaTvTheme.colors.foreground.primary,
    {
        flexGrow: 10,
    }
]);